import { render, staticRenderFns } from "./FacilityDetails.vue?vue&type=template&id=a9ab8a38&"
import script from "./FacilityDetails.vue?vue&type=script&lang=js&"
export * from "./FacilityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports